import { createAction, createReducer } from '@reduxjs/toolkit'
import { sendApiRequest } from './api'

export const GET_SCROLLERS = 'GET_SCROLLERS'
export const getScrollers = (data = {}) => {
  return async (dispatch, getState) => {
    dispatch(createAction(GET_SCROLLERS)())
    sendApiRequest('scrollers', data, 'get').then((response) => {
      if (response && response.status === 'success') {
        dispatch(getScrollersSuccess(response.data.data))
      } else {
        dispatch(getScrollersError(response))
      }
    })
  }
}

export const GET_SCROLLERS_SUCCESS = 'GET_SCROLLERS_SUCCESS'
export const getScrollersSuccess = createAction('GET_SCROLLERS_SUCCESS')

export const GET_SCROLLERS_ERROR = 'GET_SCROLLERS_ERROR'
export const getScrollersError = createAction('GET_SCROLLERS_ERROR')

export const GET_SCROLLER_BY_ID = 'GET_SCROLLER_BY_ID'
export const getScrollerById = (id, data = {}) => {
  return async (dispatch, getState) => {
    dispatch(createAction(GET_SCROLLER_BY_ID)())
    sendApiRequest(`scrollers/${id}`, data, 'get').then((response) => {
      if (response && response.status === 'success') {
        dispatch(getScrollerByIdSuccess(response.data.data))
      } else {
        dispatch(getScrollerByIdError(response))
      }
    })
  }
}

export const GET_SCROLLER_BY_ID_SUCCESS = 'GET_SCROLLER_BY_ID_SUCCESS'
export const getScrollerByIdSuccess = createAction('GET_SCROLLER_BY_ID_SUCCESS')

export const GET_SCROLLER_BY_ID_ERROR = 'GET_SCROLLER_BY_ID_ERROR'
export const getScrollerByIdError = createAction('GET_SCROLLER_BY_ID_ERROR')

const initialState = {
  scroller: {},
  scrollerError: null,
  scrollerLoading: false,
  scrollers: [],
  scrollersError: null,
  scrollersLoading: false
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(GET_SCROLLER_BY_ID, (state) => {
      state.scrollerLoading = true;
      state.scroller = {};
    })
    .addCase(GET_SCROLLER_BY_ID_SUCCESS, (state, action) => {
      state.scrollerLoading = false;
      state.scroller = action.payload;
    })
    .addCase(GET_SCROLLER_BY_ID_ERROR, (state, action) => {
      state.scrollerLoading = false;
      state.scrollerError = action.payload;
    })
    .addCase(GET_SCROLLERS, (state) => {
      state.scrollersLoading = true;
      state.scrollers = [];
    })
    .addCase(GET_SCROLLERS_SUCCESS, (state, action) => {
      state.scrollersLoading = false;
      state.scrollers = action.payload;
    })
    .addCase(GET_SCROLLERS_ERROR, (state, action) => {
      state.scrollersLoading = false;
      state.scrollersError = action.payload;
    });
});
